import React from 'react';
import colorless from './icons/colorless.png';
import darkness from './icons/darkness.png';
import dragon from './icons/dragon.png';
import lightning from './icons/lightning.png';
import fairy from './icons/fairy.png';
import fighting from './icons/fighting.png';
import fire from './icons/fire.png';
import grass from './icons/grass.png';
import psychic from './icons/psychic.png';
import metal from './icons/metal.png';
import water from './icons/water.png';
import './EnergySymbols.css';

// Pokémon TCG energy-type symbols, bundled with the app (128×128 PNGs, ~10 KB
// each) so they load with the page. Full-size originals stay in Azure blob
// storage at gradies.blob.core.windows.net/energy-symbols/.
export const ENERGY_TYPES = [
    { name: 'Colorless', icon: colorless },
    { name: 'Darkness', icon: darkness },
    { name: 'Dragon', icon: dragon },
    { name: 'Lightning', icon: lightning },
    { name: 'Fairy', icon: fairy },
    { name: 'Fighting', icon: fighting },
    { name: 'Fire', icon: fire },
    { name: 'Grass', icon: grass },
    { name: 'Psychic', icon: psychic },
    { name: 'Metal', icon: metal },
    { name: 'Water', icon: water },
];

// Look up a symbol by type name ("Fire", "fire", …). Undefined if unknown.
export const energyIcon = (name) =>
    ENERGY_TYPES.find((e) => e.name.toLowerCase() === String(name || '').toLowerCase())?.icon;

const EnergySymbols = ({ setType }) => (
    <div className="energy-symbols">
        {ENERGY_TYPES.map((energy) => (
            <img
                key={energy.name}
                src={energy.icon}
                alt={energy.name}
                className="energy-icon"
                onClick={() => setType(energy.name)}
            />
        ))}
    </div>
);

export default EnergySymbols;
